import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
//import { DowngradeInjectable } from '@angular/upgrade/static';
//declare var angular: angular.IAngularStatic;
import * as _ from 'lodash-es';
import { Observable } from 'rxjs';
import { UiService } from './core.ui.service';
import { GfTranslateService } from '../services/core.translate.service';
import { SiteConfigService } from './core.site-config.service'
import { getBytesToSize } from '../pipes/data/data.functions';
@Injectable()
export class UploadService {
    public sliceSize;
    public defaultMaxSize;

    constructor(private http: HttpClient, private uiService: UiService, private gfTranslateService: GfTranslateService, private siteConfigService: SiteConfigService) {
        this.http = http;
        this.uiService = uiService;
        this.siteConfigService = siteConfigService;
        this.gfTranslateService = gfTranslateService;

        this.sliceSize = 1000 * 1024,
        this.defaultMaxSize = this.sliceSize * 20;
    }

    /**
     * Uploads a binary object to the backend, into a given section/refId
     * 
     * IMPORTANT: deprecated method, remove when this.upload is removed
     * 
     * @param {object} file: binary object to post
     * @param {string} url: url to use for posting the binary object
     */
    public uploadBinary(file, url) {
        const formData = new FormData();
        formData.append('file', file, file.name);

        return new Promise((resolve, reject) => {
            this.http.post(url, formData)
            .toPromise()
            .then((response: any) => {
                //File uploaded successfully
                resolve({ success: true, data: response.id });
            })
            .catch((err) => {
                //File upload failed
                var errorMessage = "File " + file.name + " failed to upload.";
                if (err.status == 413) {
                    errorMessage += " The file exceeded the maximum allowed size.";
                }
                this.uiService.message.showError(errorMessage);
                reject({ success: false, errorMessage: err, status: err.status });
            });
        });
    }

    /**
     * Creates and uploads a file into the filesystem (backend)
     * 
     * IMPORTANT: deprecated method, use this.uploadFiles instead
     * 
     * @param {string} section
     * @param {int} refId
     * @param {object} file: binary object to upload
     * @param {string} name: file name
     */
    public upload(section, refId, file, name) {
        var urlFilesystem = _.template('/api/filesystem/<%= hash %>'),
            urlBinary = _.template('/api/filesystem/0/chunk?section=<%= section %>&refId=<%= refId %>&chunkSeq=1');

        return new Promise((resolve, reject) => {
            this.uploadBinary(file, urlBinary({section: section, refId: refId}))
            .then((ret: any) => {
                var hash = _.get(ret, 'data', '');
                if (hash) {
                    this.http.post(urlFilesystem({hash: hash}), {section: section, refId: refId, fileName: name})
                        .toPromise()
                        .then(function(ret: any) {
                            resolve(ret.location);
                        })
                        .catch(function() {
                            reject();
                        });
                } else {
                    reject();
                }
            })
            .catch((err) => {
                reject(err);
            });
        });
    };

    public uploadChunkFactory(section, refId, file, i, bytesStart, bytesEnd, options) {
        return (hash) => {
            if (!hash) {
                hash = 0;
            }

            return this.uploadChunk(section, refId, file, i, bytesStart, bytesEnd, hash)
                .then((ret: any) => {
                    //Call progress update callback, if defined
                    if (options.progressCallback) {
                        var bytesRemaining = file.size - bytesStart,
                            percentUploaded = _.round((bytesStart / file.size) * 100, 2),
                            percentRemaining = (100 - percentUploaded);

                        options.progressCallback(section, refId, file, bytesStart, bytesRemaining, percentUploaded, percentRemaining);  
                    }

                    //Pass the hash along
                    return ret.hash;
                })
                .catch((err) => {
                    if (options.failedCallback) {
                        options.failedCallback(section, refId, file, err.status, err.errorMessage);
                    }
                    // Re-throws the error to break the promise chain and stop subsequent chunks
                    throw err;
                });
            
        };
      }

    /**
     * Uploads one or more files to the backend filesystem and sets them to the 
     * given section and refId
     * 
     * @param {string} section
     * @param {int} refId
     * @param {file[]} files: binary objects to upload
     * @param {object} options: (optional) includes callbacks and special configurations
     * 
     * options: {
     *      successCallback: "function[section, refId, file]",
     *      failureCallback: "function[section, refId, file, errorMsg]",
     *      finishedCallback: "function[section, refId, file]"
     *      progressCallback: "function[section, refId, file, bytesUPloaded, bytesRemaining, percentUploaded, percentRemaining]"
     * }
     */
    public uploadFiles(section, refId, files, options) {
        var chain = Promise.resolve();

        if (!options) {
            options = {};
        }

        //Loop files array and chain a promise for each file
        for (const file of files) {
            chain = chain.then(() => {
                return this.uploadChunked(section, refId, file, options);
            });
        };
 
        //Returns promises chain
        return chain;
    }

    /**
     * Uploads one file to the backend filesystem and sets it to the 
     * given section and refId
     * 
     * @param {string} section
     * @param {int} refId
     * @param {file} file: binary object to upload
     * @param {object} options: (optional)
     */
    public uploadChunked(section, refId, file, options): Promise<void> {
        if (!this.validateFileSize(section, file)) {
            if (options.failureCallback) {
                options.failureCallback(section, refId, file, 'size');
            }

            if (options.finishedCallback) {
                options.finishedCallback(section, refId, file);
            }
            return Promise.resolve();
        }

        var chain = Promise.resolve(),
            sequenceCount = 1,
            bytesStart = 0,
            bytesEnd;

        //Calculate amount of chunks
        if (file.size > this.sliceSize) {
            sequenceCount = Math.ceil(file.size / this.sliceSize);
        }

        //Loop through chunk indexes and chain a promise sequence
        //for each chunk to be uplaoded
        var hash = 0;
        for(var i=1; i <= sequenceCount; i++) {
            //Set byte index to end the current chunk
            if (bytesStart + this.sliceSize <= file.size) {
                bytesEnd = bytesStart + this.sliceSize;
            } else {
                bytesEnd = file.size + 1;
            }

            var callback = this.uploadChunkFactory(section, refId, file, i, bytesStart, bytesEnd, options);
            chain = chain.then(callback);
            bytesStart += this.sliceSize;
        }

        //When ALL chunks are uploaded, either call the standard file upload completion
        //method or, if a callback was provided, call the provided one instead

        //Return a promise that resolves when all the chunked sequence
        //is either uploaded, or there's a failure
        return new Promise((resolve, reject) => {
            chain
            .then((hash) => {
                if (!options.successCallback) {
                    this.finishUpload(section, refId, file.name, options.isBulkUpload)
                        .then(function() {
                            resolve(hash);
                        })
                        .catch(function() {
                            reject();
                        });
                } else {
                    options.successCallback(section, refId, file, hash, options.isBulkUpload)
                        .then(function() {
                            resolve(null);
                        })
                        .catch(function() {
                            reject();
                        });
                }

                if (options.finishedCallback) {
                    options.finishedCallback(section, refId, file);
                }
            })
            .catch((err) => { 
                if (!options.failureCallback) {
                    this.uploadError(section, refId, file.name);
                } else {
                    options.failureCallback(section, refId, file, err);
                }

                if (options.finishedCallback) {
                    options.finishedCallback(section, refId, file);
                }

                reject();
            });
        });
    };

    /**
     * Private method to be called for finalizing
     * the upload when all chunks are uplaoded
     * 
     * @param {string} section 
     * @param {int} refId 
     * @param {string} fileName 
     * @param {string} hash 
     */
    public finishUpload(section, refId, fileName, hash) {
        var urlFilesystem = _.template('/api/filesystem/<%= hash %>');

        return new Promise((resolve, reject) => {
            this.http.post(urlFilesystem({hash: hash}), {section: section, refId: refId, fileName: fileName})
            .toPromise()
            .then((ret: any) =>  {
                resolve(ret.location);
            })
            .catch(() => {
                reject();
            });
        });
    }
    
    public uploadError(section, refId, fileName) {
        this.uiService.message.showError(
            this.gfTranslateService.translate('The file {{fileName}} in section {{section}} could not be uploaded',
            {section: section, fileName: fileName}));
    }

    public getMaxUploadSize(section) {
        switch(section) {
            case 'docmanfileversion':
            case 'docmanfolder':
                section = 'docman';
                break;

            case 'frsrelease':
                section = 'frs';
                break;

            case 'trackeritem':
            case 'trackeritem_message':
            // Temporary sections used while the owner item/message does not exist yet
            case '_trackeritem':
            case '_trackeritem_message':
                section = 'tracker';
                break;

            case 'scm':
                section = 'scm';
                break;
        }

        return _.get(this.siteConfigService.getSiteConfig(), 'maxUploadSize.' + section, this.defaultMaxSize);
    }


    /**
     * Private method. Validates file size against the maximum
     * allowed size for uploads in the given section
     * @param {string} section 
     * @param {object} file 
     * @returns {boolean}
     */
    public validateFileSize(section, file) {
        var maxSize = this.getMaxUploadSize(section);

        if (file.size > maxSize) {
            this.uiService.message.showError(
                this.gfTranslateService.translate('The file {{fileName}} in section {{section}} could not be uploaded because it exceeds the maximum allowed file size of {{maxSize}}',
                { section: section, fileName: file.name, maxSize: getBytesToSize(maxSize) })
            );

            return false;
        }

        return true;
    }

     /**
      * rivate method to upload a chunk of a file. When the last chunk is processed, it
      * resolves a promise passed as parameter to indicate completion to the initial caller
      * 
      * @param {string} section 
      * @param {int} refId 
      * @param {object} file 
      * @param {int} chunkSeq     : chunk number, starting with 1
      * @param {long} bytesStart  : byte number of the file, where the chunk begins
      * @param {object} promise   : promise passed around to be called when last chunk is uplaoded
      * @param {string} hash      : hash retrieved by the backend when chunks are uplaoded
      */
     public uploadChunk(section, refId, file, chunkSeq, bytesStart, bytesEnd, hash) {
        var urlBinary = _.template('/api/filesystem/<%= hash %>/chunk?section=<%= section %>&refId=<%= refId %>&chunkSeq=<%= chunkSeq %>');
        var blob, 
            reader = new FileReader();

        return new Promise((resolve, reject) => {
            try {
                blob = file.slice(bytesStart, bytesEnd);
    
                reader.onloadend = (event) => {
                    const fileReader = event.target as FileReader | null;
                    if (!fileReader || fileReader.readyState !== FileReader.DONE) {
                        resolve(hash);
                        return;
                    }

                    this.uploadBinary(blob, urlBinary({section: section, refId: refId, chunkSeq: chunkSeq, hash: hash}))
                        .then((ret: any) => {
                            var hash = _.get(ret, 'data', '');

                            if (hash != '') {
                                resolve({status: ret.status, hash: hash});
                            } else {
                                file.failed = true;
                                reject({status: ret.status, errorMessage: ret.errorMessage});
                            }
                        })
                        .catch((err) => {
                            file.failed = true;
                            reject({status: false, errorMessage: 'unknown error'});
                        });
                }
    
                reader.readAsBinaryString(blob);
            } catch(err) {
                setTimeout(() => {
                    file.failed = true;
                    reject({status: false, errorMessage: 'unknown error'});
                });
            }
        });
        
    }

}
